import React from 'react';
import { 
    useGetList, 
    SelectInput,
    Loading,
    useRecordContext
} from 'react-admin';

export const CachedProvincesInput = (props) => {
    const record = useRecordContext();
    const { data, loading, error } = useGetList('provinces', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'name', order: 'ASC' },
        filter: {}
    });

    if (loading) return <Loading />;
    if (error) return <span>Error al cargar las provincias</span>;

    // Get the initial value from either the record's province.id or the direct provinceId
    const initialValue = record?.province?.id || record?.provinceId;

    return (
        <SelectInput 
            {...props} 
            choices={data} 
            optionText="name"
            defaultValue={initialValue}
        />
    );
};
